import { useEffect } from 'react';
import { Space } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from "react-router-dom";

import FilterableTable from 'components/Admin/ObjectTable';

import { fetchUserSubcategories } from 'Redux/Admin/HabitManager/UserSubcategories/action';

import rootReducer from 'Redux/root-reducer';

import type { TableColumnsType } from 'antd';
import type { FilterConfig } from '@types';
import type { IUserSubcategory } from 'Redux/Admin/HabitManager/UserSubcategories/type';

import { ADMIN_PATH } from "utils/routes";

type RootState = ReturnType<typeof rootReducer>;

const SLUG = "hm-user-subcategories";

const columns: TableColumnsType<IUserSubcategory> = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    width: 120,
    render: (_, record) => (
      <Space size="middle">
        <Link to={`${ADMIN_PATH}/habit-manager/${SLUG}/${record.id}`}>{record.id}</Link>
      </Space>
    ),
  },
  {
    title: 'System Subcategory Name',
    dataIndex: 'system_subcategory_dataname',
    key: 'system_subcategory_dataname',
    width: 280,
  },
  {
    title: 'Custom Subcategory Name',
    dataIndex: 'custom_subcategory_name',
    key: 'custom_subcategory_name',
    width: 280,
  },
  {
    title: 'User',
    dataIndex: 'user_email',
    key: 'user_email',
    width: 280,
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    width: 280,
  },
];

const UserSubcategories = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  const params = new URLSearchParams(location.search);

  const user = params.get('user');
  const searchValue = params.get('search');
  const pageValue = parseInt(params.get('page') || '1');

  const { entities, ids, count, loading } = useSelector((state: RootState) => state.fetchHabitUserSubcategories);

  useEffect(() => {
    dispatch(fetchUserSubcategories({ user, search: searchValue, offset: (pageValue - 1) * 50, limit: 50 }, () => {}));
  }, [user, searchValue, pageValue, dispatch]);

  // Build filter configs for this page
  const filterConfigs: FilterConfig[] = [
    {
      type: 'search',
      paramName: 'search',
      label: 'Search',
      placeholder: 'Search...'
    },
    {
      type: 'habit-user-select',
      paramName: 'user',
      placeholder: 'Select user...',
      label: 'User'
    },
  ];

  const dataItems = ids.map(id => entities[id]);

  return (
    <FilterableTable<IUserSubcategory>
      columns={columns}
      data={dataItems}
      loading={loading}
      totalItems={count}
      createLink={`${ADMIN_PATH}/habit-manager/${SLUG}/new`}
      filters={filterConfigs}
    />
  );
}

export default UserSubcategories;
